module.exports = __webpack_public_path__ + "img/banner-deskto3-mobie.3d5366a9.png";